import React, { useEffect, useRef, useState } from "react";
import { ConfigProvider, Segmented, Drawer } from "antd";
import { temaInmersial } from "../theme/tema";
import "../theme/inmersial.css";
import { AppShell } from "./shell/AppShell";
import { MisExperiencias } from "./inicio/MisExperiencias";
import { MapaRecorrido, analizarRecorrido } from "./editor/MapaRecorrido";
import { Asistentes } from "./asistentes/Asistentes";
import { Analiticas } from "./analiticas/Analiticas";
import T360view from "./t360view";
import EscenaForm from "./escenaForm";
import ElementosForm from "./elementosForm";
import {
  VideoCameraAddOutlined,
  FolderOpenOutlined,
  AppstoreAddOutlined,
  MenuOutlined,
  LogoutOutlined,
  CodeOutlined,
  ProductOutlined,
  ClusterOutlined,
  PictureOutlined,
  UserOutlined,
  BlockOutlined,
  PlusSquareOutlined,
  SaveOutlined,
  ShareAltOutlined,
  UserSwitchOutlined,
  PieChartOutlined,
  SoundOutlined,
  EditOutlined,
  SettingOutlined,
  SwapOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  ApiOutlined,
  ArrowLeftOutlined,
  UnorderedListOutlined,
  ControlOutlined,
  StarOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Menu,
  theme,
  Tabs,
  message,
  Badge,
  Divider,
  Switch,
  Button,
  Flex,
  Input,
  Collapse,
  Space,
  Card,
  Tooltip,
} from "antd";
import ElementInspector from "./elementInspector";
import EmptyPage from "./emptyPage";
import ExperienciasForm from "./experienciaForm";
import LoadingSpin from "./loadingSpin";
import ArchivadasForm from "./archivadasForm";
import Publicar from "./publicar";
import SceneInspector from "./sceneInspector";
import GuardandoQueue from "./guardandoQueue";
import { FormEnlances } from "../FormEnlances";
import { AuthContext } from "../context/auth-context/AuthContext";
import { PantallaLogin } from "./auth-components/PantallaLogin";
import { Integraciones } from "./integraciones/Integraciones";
import apiService from "../services/apiServices";
import ModalSinPortal from "../core/components/ModalSinPortal";
import { DataSanitizerProject } from "../core/dataSanitizerProject";
import LoginForm from "./loginForm";
//import { JumpSelector } from "./automatic-tour/components/JumpSelector";
import { ModalSound } from "./designer-components/ModalSound";
import { AdminPage } from "./backoffice/pages/backOfficePage";
import { encoderSecureParams } from "../core/commons/encoderSecureParams";
import { FormScripts } from "./designer-components/FormScripts";

//import { ModalGoogleLogin } from "./auth-components/ModalGoogleLogin";
//import { type } from "@testing-library/user-event/dist/types/utility";
const { Header, Content, Sider } = Layout;

const projectInitialState = {
  id: null,
  nombre: "",
  escenas: [],
  isAnimated: false,
  linkUrl: "",
  titulo360: "",
  redesSociales: {
    facebook: "",
    twitter: "",
    youtube: "",
  },
  otras360: [],
  scripts: [],
  userId: null,
};

const useMediaQuery = (consulta) => {
  const [coincide, setCoincide] = useState(() => window.matchMedia(consulta).matches);
  useEffect(() => {
    const mq = window.matchMedia(consulta);
    const alCambiar = () => setCoincide(mq.matches);
    alCambiar();
    mq.addEventListener("change", alCambiar);
    return () => mq.removeEventListener("change", alCambiar);
  }, [consulta]);
  return coincide;
};

const escenaVacia = { fondo: "", elementos: [], inicio: { x: 0, y: 0 } };

const BaseDesigner = ({ usuarioActivo, setUsuarioActivo, googleAPI }) => {
  //state que crea el objet usuarioActivo que espera originalmente el componente
  const [usuarioActivoParaDrive, setUsuarioActivoParaDrive] = useState(
    usuarioActivo || {
      home: { id: 0 },
      c2: {
        value: {
          wt: {
            rv: "sin nombre",
          },
        },
      },
    }
  );

  const [mostrarEscenaForm, setMostrarEscenaForm] = useState(false);
  const [mostrarElementosForm, setMostrarElementosForm] = useState(false);
  const [mostrarArchivadasForm, setMostrarArchivadasForm] = useState(false);
  const [mostrarPublicar, setMostrarPublicar] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState(1);
  const [elemento, setElemento] = useState(null);
  const [camaraPos, setCamaraPos] = useState({ x: 0, y: 0 });
  const [mostrarExperienciaForm, setMostrarExperienciaForm] = useState(false);
  //tomemos el authState desde el context
  const { authState, logout, handleRefreshToken } =
    React.useContext(AuthContext);

  //state que maneja la creacion de experiencias a una API o a Drive
  //true: drive, false: API
  const [modo, setModo] = useState(false);

  //useState que maneja el show de alert para feedback de peticiones http
  const [showAlert, setShowAlert] = useState(false);
  const [alertData, setAlertData] = useState({
    type: "success",
    message: "sin titulo",
    description: "sin mensaje",
  });

  //los avisos de exito/error se muestran como toast para no desplazar el visor
  const [ultimoGuardado, setUltimoGuardado] = useState(null);
  useEffect(() => {
    if (!showAlert) return;
    const ok = alertData.type === "success";
    message.open({ type: ok ? "success" : "error", content: alertData.description });
    setUltimoGuardado({ ok, hora: new Date() });
    setShowAlert(false);
  }, [showAlert]);

  //state que maneja los mensajes del modal sin portal
  const [dataModal, setDataModal] = useState({
    titulo: "",
    mensaje: "",
  });
  const [success, setSuccess] = useState(false);
  const [showModal, setShowModal] = useState(false);

  //state que maneja el show de backoffice
  const [showBackOffice, setShowBackOffice] = useState(false);

  //navegacion del rediseño: seccion del menu lateral y vista del editor (escena o mapa)
  const [seccion, setSeccion] = useState("inicio");
  //experiencia que se abre ya elegida al ir a Asistentes desde el editor
  const [asistenteDe, setAsistenteDe] = useState(null);
  const [vistaEditor, setVistaEditor] = useState("escena");
  const [recargarLista, setRecargarLista] = useState(0);
  const [panelDerAbierto, setPanelDerAbierto] = useState(false);
  const [panelIzqAbierto, setPanelIzqAbierto] = useState(false);
  const esAngosto = useMediaQuery("(max-width: 1199px)");
  const esMovil = useMediaQuery("(max-width: 767px)");

  const [proyecto, setProyecto] = useState(projectInitialState);

  //state que maneja el titulo de la Experiencia
  const [titleExperience, setTitleExperience] = useState("");

  //metodo que detecta cambios en el input de elementos que provocan una petition http
  const handleInputChange = (e, tipo) => {
    const { value } = e.target;
    if (tipo === "titulo360") {
      setIsModifiedTitulo360(true);
      setTitulo360Value(value);
    } else if (tipo === "carrito") {
      setIsModifiedCarrito(true);
      setUrlLink(value);
    }
  };

  //manejo de peticion http para titulo 360
  const [isLoadingTitulo360, setIsLoadingTitulo360] = useState(false);
  const [isModifiedTitulo360, setIsModifiedTitulo360] = useState(false);

  //manejo de peticion http para enlace carrito
  const [isLoadingCarrito, setIsLoadingCarrito] = useState(false);
  const [isModifiedCarrito, setIsModifiedCarrito] = useState(false);

  //manejo de peticion http para animation
  const [isChangingAnimation, setIsChangingAnimation] = useState(false);

  const [cambiosGuardando, setCambiosGuardando] = useState(0);

  //const [drive] = useState(usuarioActivo?.home?.id);
  const [drive, setDrive] = useState(usuarioActivoParaDrive?.home?.id);
  const [loading, setLoading] = useState(false);
  const [escenaIndex, setEscenaIndex] = useState(null);
  const [escena, setEscena] = useState({
    fondo: "",
    elementos: [],
    inicio: { x: 0, y: 0 },
  });

  //controladores de input de linkUrl
  const [urlLink, setUrlLink] = useState("");
  const [titulo360Value, setTitulo360Value] = useState("");
  const [redesState, setRedesState] = useState({
    facebook: "",
    twitter: "",
    youtube: "",
  });

  const [otras, setOtras] = useState([]);

  const [scriptsList, setScriptsList] = useState([]);

  //estado que maneja la configuracion del sonido
  const [soundSelected, setSoundSelected] = useState(1);
  const [siderWidth, setSiderWidth] = useState(() => {
    const guardado = Number(localStorage.getItem("siderWidth"));
    return guardado >= 240 && guardado <= 620 ? guardado : 250;
  });

  const comenzarRedimensionarSider = (e) => {
    e.preventDefault();
    const inicioX = e.clientX;
    const anchoInicial = siderWidth;
    const alMover = (ev) => {
      const nuevo = Math.min(620, Math.max(240, anchoInicial + (ev.clientX - inicioX)));
      setSiderWidth(nuevo);
      localStorage.setItem("siderWidth", String(nuevo));
    };
    const alSoltar = () => {
      document.removeEventListener("mousemove", alMover);
      document.removeEventListener("mouseup", alSoltar);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
    document.addEventListener("mousemove", alMover);
    document.addEventListener("mouseup", alSoltar);
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
  };
  const [showSoundModal, setShowSoundModal] = useState(false);
  const [mostrarIntegraciones, setMostrarIntegraciones] = useState(false);
  const [ordenEscenas, setOrdenEscenas] = useState(() => {
    try {
      return localStorage.getItem("ordenEscenas") === "creacion" ? "creacion" : "az";
    } catch (e) {
      return "az";
    }
  });

  const alternarOrdenEscenas = () => {
    setOrdenEscenas((prev) => {
      const nuevo = prev === "az" ? "creacion" : "az";
      try {
        localStorage.setItem("ordenEscenas", nuevo);
      } catch (e) {}
      return nuevo;
    });
  };

  const inputUrlRef = useRef(null);
  const inputTitulo360Ref = useRef(null);
  const inputTwitterRef = useRef(null);
  const inputYoutubeRef = useRef(null);
  const inputFacebookRef = useRef(null);

  const agregarElemento = () => {
    console.log("elementos: ", proyecto.escenas.length);
    if (proyecto.escenas.length) setMostrarElementosForm(true);
    else {
      message.error("Debe crear una escena antes de agregar elementos.");
    }
  };

  //metodo que actualiza la experiencia desde API Backend ante cualquier cambio
  const actualizarExperienciaAPI = async () => {
    try {
      setLoading(true);
      const res = await apiService.getExperienceById(proyecto.id);
      setLoading(false);
      const newData = DataSanitizerProject.sanitizerDataProjecFromAPI(res);
      setProyecto(newData);
    } catch (error) {
      console.warn(error);
    } finally {
      setLoading(false);
    }
  };

  const cambiarTabKey = (tk) => {
    //if (elemento)
    setActiveTabKey(tk);
    //else message.error('Debe elemento antes ingresar al inspector.');
  };

  const rotarCamara = () => {
    console.log("llego aqui", camaraPos);

    /*let valorX = camaraPos.x * Math.PI / 180
    let valorY = camaraPos.y * Math.PI / 180 *-1*/

    const posicionActual = { x: 0, y: 0, z: 0 };

    // Calcular la diferencia en las coordenadas
    const dx = camaraPos.x - posicionActual.x;
    const dy = camaraPos.y - posicionActual.y;
    const dz = camaraPos.z - posicionActual.z;

    // Calcular los ángulos de rotación (en radianes)
    const anguloX = Math.atan2(dy, Math.sqrt(dx * dx + dz * dz));
    const anguloY = Math.atan2(dx, dz);

    console.log("llego aqui", { anguloX, anguloY });

    let camara = document.getElementById("camara");
    if (camara) {
      camara.components["look-controls"].pitchObject.rotation.x = anguloX;
      camara.components["look-controls"].yawObject.rotation.y =
        anguloY + Math.PI;
    }
  };

  const handleSwitchIsAnimated = async () => {
    setProyecto((prev) => ({ ...prev, isAnimated: !prev.isAnimated }));
    if (modo) {
      setCambiosGuardando(cambiosGuardando + 1);
    } else {
      try {
        setIsChangingAnimation(true);
        setLoading(true);
        const tokenVerified = await handleRefreshToken();
        /*en este punto elijo volver a tomar los datos del proyecto desde API por dos razones 
        1. asegurarme de tener metadata actualizada por si estan trabajando dos personas en la misma experiencia o algun otro caso
        2. mantener el sistema de trabajo paralelo con Drive, para el que no existe el valor metadata en el Project
        */
        // const datosExperiencia = await apiService.getExperienceById(
        //   tokenVerified,
        //   proyecto.id
        // );
        // const metadataDeAPI = datosExperiencia.metadata;
        // //console.log("Datos para actualizar 360: ", metadataDeAPI);
        // const dataParaPUT = {
        //   metadata: {
        //     ...metadataDeAPI,
        //     urlLink: urlLink.trim(),
        //   },
        // };

        //TODO: cambiar la forma de tomar este dato, lo hago asi por la asincronicidad pero debe corregirse de forma mas eficiente
        const dataParaPUT = { isAnimated: !proyecto.isAnimated };
        const response = await apiService.updateExperienceById(
          tokenVerified,
          proyecto.id,
          dataParaPUT
        );

        if (response) {
          setAlertData({
            type: "success",
            message: "Exito",
            description:
              "Se actualizó correctamente el link de carrito de compras",
          });
          setShowAlert(true);
        }
      } catch (error) {
        setAlertData({
          type: "error",
          message: "Error",
          description: "No se pudo actualizar el carrito de compras",
        });
        setShowAlert(true);
      } finally {
        setLoading(false);
        setIsLoadingCarrito(false);
        setIsModifiedCarrito(false);
      }
    }
  };

  const handleTitleExperienceChange = async () => {
    setProyecto((prev) => ({ ...prev, nombre: titleExperience.trim() }));
    if (modo) {
      setCambiosGuardando(cambiosGuardando + 1);
    } else {
      try {
        setLoading(true);
        const tokenVerified = await handleRefreshToken();

        const dataParaPUT = { name: titleExperience.trim() };
        const response = await apiService.updateExperienceById(
          tokenVerified,
          proyecto.id,
          dataParaPUT
        );

        if (response) {
          setAlertData({
            type: "success",
            message: "Exito",
            description:
              "Se actualizó correctamente el título de la experiencia",
          });
          setShowAlert(true);
          setIsEditingNameExperience(false);
        }
      } catch (error) {
        setAlertData({
          type: "error",
          message: "Error",
          description: "No se pudo actualizar el titulo de la experiencia",
        });
        setShowAlert(true);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleUrlLink = async () => {
    setProyecto((prev) => ({ ...prev, linkUrl: urlLink.trim() }));
    if (modo) {
      setCambiosGuardando(cambiosGuardando + 1);
    } else {
      try {
        setIsLoadingCarrito(true);
        setLoading(true);
        const tokenVerified = await handleRefreshToken();
        /*en este punto elijo volver a tomar los datos del proyecto desde API por dos razones 
        1. asegurarme de tener metadata actualizada por si estan trabajando dos personas en la misma experiencia o algun otro caso
        2. mantener el sistema de trabajo paralelo con Drive, para el que no existe el valor metadata en el Project
        */
        //console.log("PROYECTO ADNETRO DE HANDLEURLLINK: ", proyecto);
        const datosExperiencia = await apiService.getExperienceById(
          proyecto.id
        );
        const metadataDeAPI = datosExperiencia.metadata;
        //console.log("Datos para actualizar 360: ", metadataDeAPI);
        const dataParaPUT = {
          metadata: {
            ...metadataDeAPI,
            urlLink: urlLink.trim(),
          },
        };
        const response = await apiService.updateExperienceById(
          tokenVerified,
          proyecto.id,
          dataParaPUT
        );

        if (response) {
          setAlertData({
            type: "success",
            message: "Exito",
            description:
              "Se actualizó correctamente el link de carrito de compras",
          });
          setShowAlert(true);
        }
      } catch (error) {
        setAlertData({
          type: "error",
          message: "Error",
          description: "No se pudo actualizar el carrito de compras",
        });
        setShowAlert(true);
      } finally {
        setLoading(false);
        setIsLoadingCarrito(false);
        setIsModifiedCarrito(false);
      }
    }
    //setUrlLink("");
  };

  const handleDoubleClickUrlInput = () => {
    inputUrlRef.current.select();
  };

  const handleTitulo360 = async () => {
    if (modo) {
      setProyecto((prev) => ({ ...prev, titulo360: titulo360Value.trim() }));
      setCambiosGuardando(cambiosGuardando + 1);
    } else {
      try {
        setIsLoadingTitulo360(true);
        setLoading(true);
        const tokenVerified = await handleRefreshToken();
        /*en este punto elijo volver a tomar los datos del proyecto desde API por dos razones 
        1. asegurarme de tener metadata actualizada por si estan trabajando dos personas en la misma experiencia o algun otro caso
        2. mantener el sistema de trabajo paralelo con Drive, para el que no existe el valor metadata en el Project
        */
        const datosExperiencia = await apiService.getExperienceById(
          //tokenVerified,
          proyecto.id
        );
        const metadataDeAPI = datosExperiencia.metadata;
        //console.log("Datos para actualizar 360: ", metadataDeAPI);
        const dataParaPUT = {
          metadata: {
            ...metadataDeAPI,
            titulo360: titulo360Value.trim(),
          },
        };
        const response = await apiService.updateExperienceById(
          tokenVerified,
          proyecto.id,
          dataParaPUT
        );

        if (response) {
          setAlertData({
            type: "success",
            message: "Exito",
            description: "Se actualizó correctamente el título",
          });
          setShowAlert(true);
        }
      } catch (error) {
        setAlertData({
          type: "error",
          message: "Error",
          description: "No se pudo actualizar el título",
        });
        setShowAlert(true);
      } finally {
        setIsLoadingTitulo360(false);
        setLoading(false);
        setIsModifiedTitulo360(false);
      }
    }
    //setTitulo360Value("");
  };

  const handleSubmitScripts = async (nuevaLista) => {
    if (!modo) {
      try {
        const tokenVerified = await handleRefreshToken();

        /*en este punto elijo volver a tomar los datos del proyecto desde API por dos razones 
        1. asegurarme de tener metadata actualizada por si estan trabajando dos personas en la misma experiencia o algun otro caso        
        */

        const datosExperiencia = await apiService.getExperienceById(
          proyecto.id
        );
        const metadataDeAPI = datosExperiencia.metadata;
        //console.log("Datos para actualizar 360: ", metadataDeAPI);
        const dataParaPUT = {
          metadata: {
            ...metadataDeAPI,
            scripts: nuevaLista,
          },
        };
        const response = await apiService.updateExperienceById(
          tokenVerified,
          proyecto.id,
          dataParaPUT
        );
        if (response) {
          setAlertData({
            type: "success",
            message: "Exito",
            description: "Se actualizaron correctamente los scripts",
          });
          setShowAlert(true);
        }
      } catch (error) {
        setAlertData({
          type: "error",
          message: "Error",
          description: "No se pudieron actualizar los scripts",
        });
        setShowAlert(true);
      }
    }
  };

  const handleSubmitEnlaces = async (nuevaLista) => {
    if (modo) {
      setOtras([...nuevaLista]);
      setProyecto((prev) => ({ ...prev, otras360: nuevaLista }));
      setCambiosGuardando(cambiosGuardando + 1);
    } else {
      try {
        const tokenVerified = await handleRefreshToken();

        /*en este punto elijo volver a tomar los datos del proyecto desde API por dos razones 
        1. asegurarme de tener metadata actualizada por si estan trabajando dos personas en la misma experiencia o algun otro caso
        2. mantener el sistema de trabajo paralelo con Drive, para el que no existe el valor metadata en el Project
        */
        const datosExperiencia = await apiService.getExperienceById(
          //tokenVerified,
          proyecto.id
        );
        const metadataDeAPI = datosExperiencia.metadata;
        //console.log("Datos para actualizar 360: ", metadataDeAPI);
        const dataParaPUT = {
          metadata: {
            ...metadataDeAPI,
            otras360: nuevaLista,
          },
        };
        const response = await apiService.updateExperienceById(
          tokenVerified,
          proyecto.id,
          dataParaPUT
        );
        if (response) {
          setAlertData({
            type: "success",
            message: "Exito",
            description: "Se actualizaron correctamente los enlaces",
          });
          setShowAlert(true);
        }
      } catch (error) {
        setAlertData({
          type: "error",
          message: "Error",
          description: "No se pudieron actualizar los enlaces",
        });
        setShowAlert(true);
      }
    }
  };

  const handleSound = async (opcionSound) => {
    if (modo) {
      setProyecto((prev) => ({ ...prev, sound: soundSelected }));
      setCambiosGuardando(cambiosGuardando + 1);
    } else {
      try {
        setLoading(true);
        const tokenVerified = await handleRefreshToken();
        /*en este punto elijo volver a tomar los datos del proyecto desde API por dos razones 
        1. asegurarme de tener metadata actualizada por si estan trabajando dos personas en la misma experiencia o algun otro caso
        2. mantener el sistema de trabajo paralelo con Drive, para el que no existe el valor metadata en el Project
        */
        const datosExperiencia = await apiService.getExperienceById(
          //tokenVerified,
          proyecto.id
        );
        const metadataDeAPI = datosExperiencia.metadata;
        //console.log("Datos para actualizar 360: ", metadataDeAPI);
        const dataParaPUT = {
          metadata: {
            ...metadataDeAPI,
            sound: opcionSound,
          },
        };
        const response = await apiService.updateExperienceById(
          tokenVerified,
          proyecto.id,
          dataParaPUT
        );

        if (response) {
          setAlertData({
            type: "success",
            message: "Exito",
            description: "Se actualizó correctamente el sonido",
          });
          setShowAlert(true);
        }
      } catch (error) {
        setAlertData({
          type: "error",
          message: "Error",
          description: "No se pudo actualizar el sonido",
        });
        setShowAlert(true);
      } finally {
        setLoading(false);
      }
    }
    //setTitulo360Value("");
  };

  const handleRedesSave = () => {
    setProyecto((prev) => ({ ...prev, redesSociales: redesState }));
    setCambiosGuardando(cambiosGuardando + 1);
  };

  const handleDoubleClicTitulo360Input = () => {
    inputTitulo360Ref.current.select();
  };

  const handleDoubleClicTwitterInput = () => {
    inputTwitterRef.current.select();
  };

  const handleDoubleClicFacebookInput = () => {
    inputFacebookRef.current.select();
  };

  const handleDoubleClicYoutubeInput = () => {
    inputYoutubeRef.current.select();
  };

  useEffect(() => {
    rotarCamara();
  }, [camaraPos]);

  const guardarCambios = async (p) => {
    //setCambiosGuardando(cambiosGuardando+1);
    setLoading(true);
    //console.log("antes de guardar: ", p);
    let response = await googleAPI.saveFile(p, proyecto.id);
    //console.log("al guardar: ", response);
    setCambiosGuardando(0);
    setLoading(false);
    //setCambiosGuardando(cambiosGuardando-1);
  };

  //este metodo puede recibir dos banderas "principal" u "origen" segun eso actualiza uno u otro valor de la escena
  const guardarCambiosEscena = async (e, bandera) => {
    if (modo) {
      setCambiosGuardando(cambiosGuardando + 1);
    } else {
      if (bandera === "principal") {
        setEscena({ ...e });        

        proyecto.escenas = proyecto.escenas.map((es) => {
          return { ...es, principal: false };
        });
        proyecto.escenas[escenaIndex] = e;
        setProyecto({ ...proyecto });

        try {
          const tokenVerified = await handleRefreshToken();

          //agrupemos las promesas
          const updatePromises = proyecto.escenas.map((escena) => {
            const bodyDataForPut = {
              principal: escena.principal,
            };

            return apiService.updateSceneById(
              tokenVerified,
              escena.id,
              bodyDataForPut
            );
          });

          //resolvemos todas las promesas en paralelo
          const responses = await Promise.all(updatePromises);

          const allSuccess = responses.every((response) => response);
          if (allSuccess) {
            setAlertData({
              type: "success",
              message: "Exito",
              description: "Se actualizó correctamente la escena principal",
            });
            setShowAlert(true);
          }
        } catch (error) {
          console.warn(error);
          setAlertData({
            type: "error",
            message: "Error",
            description: "Error al actualizar la escena principal",
          });
          setShowAlert(true);
        }
      } else if (bandera === "origen") {
        try {
          const tokenVerified = await handleRefreshToken();

          const bodyDataForPut = {
            initial: escena.inicio,
          };

          const res = await apiService.updateSceneById(
            tokenVerified,
            escena.id,
            bodyDataForPut
          );

          //console.log("RESPUESTA DE ACTUALIZAR ORIGEN: ", res);

          if (res) {
            setAlertData({
              type: "success",
              message: "Exito",
              description: "Éxito al actualizar el punto de inicio",
            });
            setShowAlert(true);
          }
        } catch (error) {
          console.warn(error);
          setAlertData({
            type: "error",
            message: "Error",
            description: "Error al actualizar la escena principal",
          });
          setShowAlert(true);
        }
      } else if (bandera === "titulo") {
        try {
          const tokenVerified = await handleRefreshToken();

          const bodyDataForPut = {
            title: escena.titulo,
          };

          const res = await apiService.updateSceneById(
            tokenVerified,
            escena.id,
            bodyDataForPut
          );

          //console.log("RESPUESTA DE ACTUALIZAR ORIGEN: ", res);

          if (res) {
            setAlertData({
              type: "success",
              message: "Exito",
              description: "Título actualizado correctamente",
            });
            setShowAlert(true);
          }
        } catch (error) {
          console.warn(error);
          setAlertData({
            type: "error",
            message: "Error",
            description: "No se pudo actualizar el título",
          });
          setShowAlert(true);
        }
      }
    }
  };

  //metodo que recorre todas las escenas de la Experiencia y ejecuta la actualizacion del campo principal
  const actualizarEscenaPrincipalAPI = async () => {
    try {
      const tokenVerified = await handleRefreshToken();
      //console.log("PROYECTO ADENTRO DE ACTUALIZADOR: ", proyecto);

      //agrupemos las promesas
      const updatePromises = proyecto.escenas.map((escena) => {
        const bodyDataForPut = {
          principal: escena.principal,
        };
        return apiService.updateSceneById(
          tokenVerified,
          escena.id,
          bodyDataForPut
        );
      });
      //resolvemos todas las promesas en paralelo
      const responses = await Promise.all(updatePromises);

      const allSuccess = responses.every((response) => response);
      if (allSuccess) {
        setAlertData({
          type: "success",
          message: "Exito",
          description: "Se actualizó correctamente la escena principal",
        });
        setShowAlert(true);
      }
    } catch (error) {
      setAlertData({
        type: "erro",
        message: "Error",
        description: "Error al actualizar la escena principal",
      });
      setShowAlert(true);
    } finally {
      setLoading(false);
    }
  };

  const guardarCambiosElemento = (e) => {
    setElemento(e);
    if (modo) {
      setCambiosGuardando(cambiosGuardando + 1);
      //console.log("cambiando elemento");
    }
  };

  const actualizarElementoAPI = async (e) => {
    try {
      const elementsDataForPut = {
        elements: [...proyecto.escenas[escenaIndex].elementos],
      };
      const tokenVerified = await handleRefreshToken();
      const response = await apiService.updateSceneById(
        tokenVerified,
        proyecto.escenas[escenaIndex].id,
        elementsDataForPut
      );
      if (response) {
        setAlertData({
          type: "success",
          message: "Exito",
          description: "Se actualizó correctamente el elemento",
        });
        setShowAlert(true);
      }
    } catch (error) {
      setAlertData({
        type: "erro",
        message: "Error",
        description: "Error al actualizar el elemento",
      });
      setShowAlert(true);
    } finally {
      setLoading(false);
    }
  };

  const items1 = [
    {
      label: `Usuario Activo:  ${authState.username || "AN"} `,
      icon: UserSwitchOutlined,
      hijos: [
        // {
        //   label: "Opciones",
        //   icon: React.createElement(MenuOutlined),
        //   onClick: () => googleAPI.listFiles().then((x) => console.log(x)),
        // },
        {
          label: "Cerrar Sesion",
          icon: React.createElement(LogoutOutlined),
          onClick: () => {
            if (!modo) {
              setProyecto(projectInitialState);
              setShowBackOffice(false);
            }
            logout();
          },
        },
      ],
    },
    // {
    //   //label: usuarioActivo?.c2?.value?.wt?.rV ,
    //   label: usuarioActivoParaDrive.c2?.value?.wt?.rV || "no logeado",
    //   icon: UserOutlined,
    //   hijos: [
    //     {
    //       label: "Opciones",
    //       icon: React.createElement(MenuOutlined),
    //       onClick: () => googleAPI.listFiles().then((x) => console.log(x)),
    //     },
    //     {
    //       label: "Cerrar Sesion",
    //       icon: React.createElement(LogoutOutlined),
    //       onClick: () => {
    //         googleAPI.logOut();
    //         setUsuarioActivoParaDrive({
    //           home: { id: 0 },
    //           c2: {
    //             value: {
    //               wt: {
    //                 rv: "sin nombre",
    //               },
    //             },
    //           },
    //         });
    //         if (modo) {
    //           setProyecto(projectInitialState);
    //         }
    //       },
    //     },
    //   ],
    // },
    {
      label: "Experiencias",
      icon: VideoCameraAddOutlined,
      hijos: [
        {
          label: "Nueva",
          icon: React.createElement(AppstoreAddOutlined),
          onClick: () => {
            setMostrarExperienciaForm(true);
            // if (modo && drive !== 0) {
            //   setMostrarExperienciaForm(true);
            // } else {
            //   return;
            // }
          },
        },
        {
          label: "Archivadas",
          icon: React.createElement(FolderOpenOutlined),
          onClick: async () => {
            setLoading(true);
            let e;
            if (modo) {
              //console.log(drive);
              if (drive === 0) {
                setLoading(false);
                return;
              }
              e = await googleAPI.getExperiencias(drive);
              // console.log("forma de e al traer de drive", e);
              // console.log(e);
            } else {
              const tokenVerified = await handleRefreshToken();
              e = await apiService.getExperiencesByUser(tokenVerified);
              e = e.map((item) => {
                return {
                  id: item.id,
                  name: item.name,
                };
              });
            }
            if (e.length) {
              //setUsuarioActivo({ ...usuarioActivo, experiencias: e });
              setUsuarioActivoParaDrive({
                ...usuarioActivoParaDrive,
                experiencias: e,
              });
              setMostrarArchivadasForm(true);
              // console.log(
              //   "OBJETO USUARIO ACTIVO QUE MANEJA EL BASE DESIGNER >>>>>>>>>>>>>>>>>>>>>>>>"
              // );
              //console.log(usuarioActivoParaDrive);
            } else alert("No hay experiencias archivadas.");
            setLoading(false);
          },
        },
      ],
    },
    {
      label: "Guardar",
      icon: SaveOutlined,
      onClick: () => guardarCambios(proyecto),
      oculto: cambiosGuardando == 0,
    },
    {
      label: "Analíticas",
      icon: PieChartOutlined,
      onClick: () => {
        const addData = {
          userId: authState.userId,
          refreshToken: authState.refreshToken,
          // token: authState.token,
          // role: authState.role,
          // username: authState.username,
        };
        const secureParams = encoderSecureParams(addData);
        const url_destino = `${process.env.REACT_APP_BASE_URL_ANALYTICS}/${authState.userId}?data=${secureParams}`;
        //console.log("%c URL DESTINO: ", "color: orange", url_destino);

        window.open(`${url_destino}`, "_blank");
      },
      oculto: modo,
    },
    {
      label: "Integraciones",
      icon: ApiOutlined,
      onClick: () => setMostrarIntegraciones(true),
      oculto: modo,
    },
    {
      label: "Administración",
      icon: SettingOutlined,
      onClick: () => {
        // const url_destino = window.location.href + "backoffice";
        // console.log("%c URL DESTINO: ", "color: orange", url_destino);
        // window.open(`${url_destino}`, "_blank");
        setProyecto(projectInitialState);
        setShowBackOffice(true);
      },
      oculto: authState.role !== null ? authState.role !== "SUPER_ADMIN" : true,
    },
  ]
    .filter((x) => !x.oculto)
    .map((opcion, key) => ({
      key,
      icon: React.createElement(opcion.icon),
      label: opcion.label,
      children: opcion.hijos,
      onClick: opcion.onClick,
    }));

  const [menuLateral, setMenuLateral] = useState([
    {
      label: "Escenas",
      icon: ClusterOutlined,
      submenu: [
        {
          label: "Nueva...",
          icon: PlusSquareOutlined,
          funcion: () => setMostrarEscenaForm(true),
        },
      ],
    },
    {
      label: "Elementos",
      icon: ProductOutlined,
      submenu: [
        {
          label: "Nuevo...",
          icon: PlusSquareOutlined,
          funcion: agregarElemento,
        },
      ],
    },
    {
      label: "Sonido Ambiente",
      icon: ShareAltOutlined,
      submenu: [
        {
          label: "Configurar sonido ambiente",
          icon: CodeOutlined,
          funcion: () => setShowSoundModal(true),
        },
      ],
    },
    {
      label: "Publicar",
      icon: ShareAltOutlined,
      submenu: [
        {
          label: "Link para compartir",
          icon: CodeOutlined,
          funcion: () => setMostrarPublicar(true),
        },
      ],
    },
  ]);

  const getMenuLateral = () => {
    return menuLateral.map((opcion, index) => {
      const key = String(index + 1);
      return {
        key: `sub${key}`,
        icon: React.createElement(opcion.icon),
        label: opcion.label,
        children: opcion.submenu.map((subopcion, j) => {
          const subKey = index * 4 + j + 1;
          return {
            key: subKey,
            label: subopcion.label,
            icon: React.createElement(subopcion.icon),
            onClick: subopcion.funcion,
            onDoubleClick: () => {
              console.log("doble click");
            },
          };
        }),
      };
    });
  };

  useEffect(() => {
    // console.log(
    //   "USUARIO ACTIVO EN USEEFFECT DESPUES DE GOOGLE LOGIN  : ",
    //   usuarioActivoParaDrive
    // );
    // console.log(
    //   "valor de DRIVE ante de actualizar",
    //   usuarioActivoParaDrive?.home?.id
    // );
    setDrive(usuarioActivoParaDrive?.home?.id);
  }, [usuarioActivoParaDrive]);

  useEffect(() => {}, [authState]);

  useEffect(() => {
    const dataUserGoogle = JSON.parse(localStorage.getItem("user"));
    //console.log("datos de usuario desde LOCALSTORAGE: ", dataUserGoogle);
    if (dataUserGoogle) {
      setUsuarioActivoParaDrive(dataUserGoogle);
    }
  }, []);

  useEffect(() => {
    const recorrido = analizarRecorrido(proyecto.escenas);
    console.log("Proyecto en UseEffect!");
    console.log(proyecto);
    setUrlLink(proyecto.linkUrl);
    setTitulo360Value(proyecto.titulo360);
    setRedesState(proyecto.redesSociales);
    setOtras(proyecto.otras360);
    setScriptsList(proyecto.scripts || []);
    //setSoundSelected(proyecto.sound || 1);
    setTitleExperience(proyecto.nombre);
    if (proyecto.escenas.length && escena.fondo == "") cargarEscena(0);
    //console.log("%c ESCENEA INDEX EN USE EFFECT!", "color: green", escenaIndex);

    setMenuLateral([
      {
        label: "Escenas",
        icon: ClusterOutlined,
        submenu: [...proyecto.escenas]
          .sort((a, b) =>
            ordenEscenas === "az"
              ? a.titulo.localeCompare(b.titulo)
              : Number(b.principal) - Number(a.principal)
          )
          .map((e, i) => {
            const originalIndex = proyecto.escenas.findIndex(
              (scene) => scene === e
            );
            return {
              label: (
                <>
                  {e.principal ? (
                    <Badge title="Escena Principal" count={"P"} size="small" />
                  ) : null}
                  {recorrido.salidas[originalIndex]?.size === 0 && (
                    <span className="inm-punto-aviso" title="Sin salida a otra escena" />
                  )}
                  <Tooltip
                    title={e.titulo}
                    overlayInnerStyle={{
                      backgroundColor: "rgba(0,0,0,0.7)",
                      color: "white",
                    }}
                  >
                    <span style={{ marginLeft: 10 }}>{e.titulo}</span>
                  </Tooltip>
                </>
              ),
              icon: PictureOutlined,
              funcion: () => cargarEscena(originalIndex),
            };
          })
          .concat([
            {
              label: "Nueva...",
              icon: PlusSquareOutlined,
              funcion: () => {
                if (proyecto.escenas.length > 0) {
                  // Check if any scene has principal set to true
                  const hasPrincipal = proyecto.escenas.some(
                    (scene) => scene.principal
                  );

                  if (!hasPrincipal) {
                    // If no principal scene is set, show a modal
                    setSuccess(false);
                    setDataModal({
                      titulo: "Advertencia",
                      mensaje:
                        "Debe definir una escena principal antes de crear una nueva escena.",
                    });
                    setShowModal(true);
                  } else {
                    // If a principal scene is set, proceed to show the form
                    setMostrarEscenaForm(true);
                  }
                } else {
                  // If no scenes exist yet, show the form
                  setMostrarEscenaForm(true);
                }
                //   setMostrarEscenaForm(true)
              },
            },
            {
              label:
                ordenEscenas === "az"
                  ? "Orden: A–Z (cambiar)"
                  : "Orden: creación (cambiar)",
              icon: SwapOutlined,
              funcion: alternarOrdenEscenas,
            },
          ]),
      },
      {
        label: "Elementos",
        icon: ProductOutlined,
        submenu: escena.elementos
          .sort((a, b) => a.nombre.localeCompare(b.nombre))
          .map((e) => {
            return {
              label: (
                <>
                  <Tooltip
                    title={e.nombre}
                    overlayInnerStyle={{
                      backgroundColor: "rgba(0,0,0,0.7)",
                      color: "white",
                    }}
                  >
                    <span style={{ marginLeft: 10 }}>{e.nombre}</span>
                  </Tooltip>
                </>
              ),
              icon: BlockOutlined,
              funcion: () => {
                setEditingElement(e);
                setCamaraPos(e.position);
              },
            };
          })
          .concat([
            {
              label: "Nuevo...",
              icon: PlusSquareOutlined,
              funcion: agregarElemento,
            },
          ]),
      },
      {
        label: "Sonido Ambiente",
        icon: SoundOutlined,
        submenu: [
          {
            label: "Configurar sonido ambiente",
            icon: CodeOutlined,
            funcion: () => setShowSoundModal(true),
          },
        ],
      },
      {
        label: "Publicar",
        icon: ShareAltOutlined,
        submenu: [
          {
            label: "Link para compartir",
            icon: CodeOutlined,
            funcion: () => setMostrarPublicar(true),
          },
        ],
      },
    ]);
  }, [proyecto, escena, ordenEscenas]);

  // useEffect(() => {
  // // Force T360view component to reload when escena changes
  // if (escena.fondo) {
  //   const t360Container = document.getElementById('t360-container');
  //   if (t360Container) {
  //   t360Container.innerHTML = '';
  //   setTimeout(() => {
  //     setEscena({...escena});
  //   }, 100);
  //   }
  // }
  // }, [escenaIndex]);

  const eliminarExperiencia = async (id) => {
    if (modo) {
      googleAPI.deleteFile(id);
    } else {
      setLoading(true);

      try {
        const tokenVerified = await handleRefreshToken();
        const res = await apiService.deleteExperienceById(tokenVerified, id);
        //console.log(res);
        setSuccess(true);
        setDataModal({
          titulo: "Exito",
          mensaje: "Experiencia eliminada con Exito...",
        });
        setShowModal(true);
      } catch (error) {
        setSuccess(false);
        setDataModal({
          titulo: "Error",
          mensaje: "Error al eliminar Experiencia...",
        });
        setShowModal(true);
      } finally {
        setLoading(false);
      }
    }
  };

  //metodo que crea nueva experiencia en Drive
  const crearExperiencia = async (newExp) => {
    //console.log("DATA DE NewExp: ", newExp);
    setMostrarExperienciaForm(false);
    const newProyecto = {
      id: null,
      nombre: newExp.titulo,
      escenas: [],
      isAnimated: true,
      linkUrl: newExp.linkUrl,
      titulo360: newExp.titulo360,
      redesSociales: newExp.redesSociales,
      otras360: newExp.otras360,
    };
    // console.log(
    //   "DATA DE NUEVO PROYECTO ANTES DE ENVIAR A LA API: ",
    //   newProyecto
    // );
    setLoading(true);
    let nuevoArchivo = await googleAPI.createFile(
      newExp.titulo + "-" + Date.now() + ".grf",
      drive,
      newProyecto
    );
    let respuesta = JSON.parse(nuevoArchivo.body);
    //console.log(respuesta);
    setProyecto({ ...newProyecto, id: respuesta.id });
    await googleAPI.setReadPermission(respuesta.id);
    setLoading(false);
  };

  //metodo que crea nueva experiencia en Api Backend
  const crearExperienciaAPI = async (data) => {
    const newProyecto = {
      name: data.titulo,
      description: "",
      isAnimated: false,
      url: "",
      socialMedia: "",
      metadata: {},
    };

    try {
      setLoading(true);
      const tokenVerified = await handleRefreshToken();
      const res = await apiService.postNewExperience(
        newProyecto,
        tokenVerified
      );
      //console.log("Respuesta al crear una experiencia: ", res);

      setMostrarExperienciaForm(false);

      setAlertData({
        type: "success",
        message: "Éxito",
        description: "Experiencia creada",
      });
      setShowAlert(true);
      const newData = DataSanitizerProject.sanitizerDataProjecFromAPI(res);
      setProyecto(newData);

      setLoading(false);
    } catch (error) {
      console.log(error);
      setSuccess(false);
      //setError(true);
      setDataModal({
        titulo: "Error al crear una experiencia",
        mensaje: "controle los datos por favor...",
      });
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const GenerarNuevaExperiencia = (data) => {
    if (!modo) {
      crearExperienciaAPI(data);
    } else {
      crearExperiencia(data);
    }
  };

  const cargarEscena = (indice) => {
    if (indice < 0) {
      setEscena({
        fondo: "",
        elementos: [],
        inicio: { x: 0, y: 0 },
      });
      return;
    }
    //console.log("AL CARGAR ESCENA: ", proyecto.escenas[indice]);
    setEscena(proyecto.escenas[indice]);
    setElemento(null);
    setEscenaIndex(indice);
  };

  const eliminarElemento = async (elemento) => {
    let index = proyecto.escenas[escenaIndex].elementos.findIndex(
      (e) => e.id === elemento.id
    );
    proyecto.escenas[escenaIndex].elementos.splice(index, 1);
    setEscena({ ...proyecto.escenas[escenaIndex] });
    //setProyecto({ ...proyecto }); 
    if (modo) {
      setCambiosGuardando(cambiosGuardando + 1);
    } else {
      try {
        const elementsDataForPut = {
          elements: [...proyecto.escenas[escenaIndex].elementos],
        };
        const tokenVerified = await handleRefreshToken();
        await apiService.updateSceneById(
          tokenVerified,
          proyecto.escenas[escenaIndex].id,
          elementsDataForPut
        );
      } catch (error) {
        console.log(error);
      }
    }
  };

  const setEditingElement = (e) => {
    setElemento(escena.elementos.find((x) => x.id == e.id));
    setActiveTabKey(2);
    if (esAngosto) setPanelDerAbierto(true);
  };

  const abrirExperiencia = async (id) => {
    setLoading(true);
    try {
      const res = await apiService.getExperienceById(id);
      const newData = DataSanitizerProject.sanitizerDataProjecFromAPI(res);
      //se limpia la escena para que el efecto de proyecto cargue la primera de la experiencia nueva
      setEscena(escenaVacia);
      setEscenaIndex(null);
      setElemento(null);
      setVistaEditor("escena");
      setUltimoGuardado(null);
      setProyecto(newData);
    } catch (error) {
      message.error("No se pudo abrir la experiencia");
    } finally {
      setLoading(false);
    }
  };

  const cerrarExperiencia = () => {
    setProyecto(projectInitialState);
    setEscena(escenaVacia);
    setEscenaIndex(null);
    setElemento(null);
    setPanelDerAbierto(false);
    setPanelIzqAbierto(false);
    setRecargarLista((n) => n + 1);
  };

  const navegar = (clave) => {
    if (proyecto.id) cerrarExperiencia();
    setSeccion(clave);
    setShowBackOffice(clave === "admin");
  };

  //el asistente se configura (con vista previa) en la pagina Asistentes, no dentro del editor
  const configurarAsistente = () => {
    setAsistenteDe(proyecto.id);
    navegar("asistentes");
  };

  const abrirTableroAnaliticas = () => {
    const secureParams = encoderSecureParams({
      userId: authState.userId,
      refreshToken: authState.refreshToken,
    });
    window.open(
      `${process.env.REACT_APP_BASE_URL_ANALYTICS}/${authState.userId}?data=${secureParams}`,
      "_blank"
    );
  };

  //metodo nuevo que agrega una escena a la API
  const addEscenaToAPI = async (values) => {
    let linkHome = {};

    //TODO: revisar si es necesario agregar el link de home en este if
    if (proyecto.escenas.length > 0) {
      //auxiliar para agregar el link de home
      const principal_scene = proyecto.escenas.find((scene) => scene.principal);
      linkHome = {
        id: "" + Date.now(),
        tipo: 2,
        escena: principal_scene.titulo,
        nombre: principal_scene.titulo,
        position: { x: 3.29, y: -10, z: -22 },
        rotation: { x: 0, y: 0, z: 0 },
      };
    }

    if (values.fromArray) {
      if (proyecto.escenas.length === 0) {
        linkHome = {
          id: "" + Date.now(),
          tipo: 2,
          escena: "",
          nombre: "home",
          position: { x: 3.29, y: -10, z: -22 },
          rotation: { x: 0, y: 0, z: 0 },
        };
      } else {
        const principal_scene = proyecto.escenas.find(
          (scene) => scene.principal
        );
        linkHome = {
          id: "" + Date.now(),
          tipo: 2,
          escena: principal_scene.titulo,
          nombre: principal_scene.titulo,
          position: { x: 3.29, y: -10, z: -22 },
          rotation: { x: 0, y: 0, z: 0 },
        };
      }
    }
    const tokenVerified = await handleRefreshToken();
    setLoading(true);
    const newEscena = {
      title: values.titulo,
      description: values.descripcion,
      image360: values.imageContent,
      experienceId: proyecto.id,
      principal: values.fromArray ? false : proyecto.escenas.length == 0,
      initial: { x: 0, y: 0 },
      elements: Object.keys(linkHome).length > 0 ? [linkHome] : [],
      token: tokenVerified,
    };
    try {
      const res = await apiService.postNewScene(newEscena);
      //console.log(res);
      setMostrarEscenaForm(false);
      setSuccess(true);
      setDataModal({
        titulo: "Exito",
        mensaje: "Nueva Escena agregada con Exito...",
      });
      setShowModal(true);
    } catch (error) {
      setSuccess(false);
      console.log("%c ERROR AL CREAR ESCENA EN DESIGNER: ", "color: orange", {
        error,
      });
      setDataModal({ titulo: "Error al Crear Escena", mensaje: `${error}` });
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const addEscena = (values) => {
    const newEscena = {
      titulo: values.titulo,
      fondo: values.imageContent,
      elementos: [],
      inicio: { x: 0, y: 0 },
      principal: proyecto.escenas.length == 0,
    };
    //const newEscena = {label: values.titulo, imagen: values.imageContent, icon: PictureOutlined, funcion:() => cargarEscena(newEscenaFile)};
    proyecto.escenas.push(newEscena);

    setProyecto({ ...proyecto });
    setCambiosGuardando(cambiosGuardando + 1);
    cargarEscena(proyecto.escenas.length - 1);

    setMostrarEscenaForm(false);
  };

  const handleCreateNewScene = (values) => {
    if (modo) {
      addEscena(values);
    } else {
      addEscenaToAPI(values).then(() => {
        actualizarExperienciaAPI();
      });
    }
  };

  const abrir = () => {
    var myReader = new FileReader();
    myReader.addEventListener("loadend", function (e) {
      //console.log(e.srcElement.result); //prints a string
    });
    //start the reading process.

    fetch(
      "https://drive.google.com/uc?id=1sX0wMfdQdv64jk2pUdS-Ma_BZfrI6wGv&export=download",
      { mode: "no-cors" }
    ).then((x) => x.blob().then((y) => myReader.readAsText(y)));
  };

  const handleRename = (values) => {
    googleAPI
      .renameFile(proyecto.id, proyecto.nombre)
      .then((res) => {
        alert("El archivo ha sido renombrado con Exito!!");
      })
      .catch((err) => {
        alert(
          "ERRRO: No pudo renombrarse el archivo, por favor, vuelva a loguearse y repita la operación."
        );
      });
  };

  const addElemento = async (values) => {
    //  const tmpEscena = escena;
    //console.log("%c CREANDO UN ELEMENTO NUEVO", "color: green", values);
    const newElemento = {
      id: "" + Date.now(),
      nombre: values.nombre,
      position: { x: 18, y: -10, z: -22 },
      rotation: { x: 0, y: 0, z: 0 },
      tipo: parseInt(values.elemento),
    };

    //escena.elementos.push(newElemento)
    //console.log("escena", escena);

    setEscena({ ...escena, elementos: [...escena.elementos, newElemento] });
    // console.log("proyecto.escenas[escenaIndex]", proyecto.escenas[escenaIndex]);
    // console.log("escenaIndex", escenaIndex);

    proyecto.escenas[escenaIndex] = {
      ...proyecto.escenas[escenaIndex],
      elementos: [...proyecto.escenas[escenaIndex].elementos, newElemento],
    };
    //setProyecto({ ...proyecto });
    if (modo) {
      setCambiosGuardando(cambiosGuardando + 1);
      //setMostrarElementosForm(false);
    } else {
      try {
        const elementsDataForPut = {
          elements: [...proyecto.escenas[escenaIndex].elementos],
        };
        const tokenVerified = await handleRefreshToken();
        await apiService.updateSceneById(
          tokenVerified,
          proyecto.escenas[escenaIndex].id,
          elementsDataForPut
        );
        setAlertData({
          type: "success",
          message: "Éxito",
          description: "Elemento creado",
        });
        setShowAlert(true);

        setLoading(false);
      } catch (error) {
        console.log(error);
        setSuccess(false);
        //setError(true);
        setDataModal({
          titulo: "Error al crear un nuevo elemento",
          mensaje: "controle los datos por favor...",
        });
        setShowModal(true);
      } finally {
        setLoading(false);
      }
    }
    setMostrarElementosForm(false);
  };

  const tabItems = [
    {
      key: 1,
      label: <p style={{ color: "white" }}>Opciones</p>,
      children: (
        <>
          <Menu
            mode="inline"
            style={{ height: "100%" }}
            theme="dark"
            items={getMenuLateral()}
          />

          {/* <Divider orientation="left">Animation</Divider> */}
          <Divider
            orientation="left"
            style={{ color: "white", borderColor: "#303030", margin: "16px 0 8px" }}
          >
            Ajustes de experiencia
          </Divider>
          <Collapse
            items={[
              {
                key: "carrito_option",
                label: <p style={{ color: "white", margin: 0 }}>Carrito</p>,
                children: (
                  <Card
                    style={{
                      backgroundColor: "#071529",
                      width: "100%",
                      margin: 0,
                      padding: 0,
                      border: "none", // Remove card border
                    }}
                  >
                    <Input
                      ref={inputUrlRef}
                      onChange={(e) => handleInputChange(e, "carrito")}
                      placeholder="https://www.google.com/"
                      style={{ width: "100%", marginBottom: 16 }}
                      value={urlLink}
                      onDoubleClick={handleDoubleClickUrlInput}
                    />
                    <Button
                      style={{ color: "white" }}
                      disabled={!isModifiedCarrito || isLoadingCarrito}
                      onClick={handleUrlLink}
                      type="primary"
                      block
                    >
                      Guardar
                    </Button>
                  </Card>
                ),
              },
              {
                key: "titulo_option",
                label: <p style={{ color: "white", margin: 0 }}>Título</p>,
                children: <>
                    <Card
                      style={{
                        backgroundColor: "#071529",
                        width: "100%",
                        margin: 0,
                        padding: 0,
                        border: "none",
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                      }}
                    >
                      <Input
                        ref={inputTitulo360Ref}
                        //onChange={(e) => setTitulo360Value(e.target.value)}
                        onChange={(e) => handleInputChange(e, "titulo360")}
                        placeholder="titulo para despliegue 360"
                        style={{ width: "100%" }}
                        value={titulo360Value}
                        onDoubleClick={handleDoubleClicTitulo360Input}
                      />
                      <Button
                        onClick={handleTitulo360}
                        disabled={!isModifiedTitulo360 || isLoadingTitulo360}
                        type="primary"
                        style={{ color: "white", marginTop: 20 }}
                      >
                        Guardar Titulo
                      </Button>
                    </Card>
                  </>,
              },
              {
                key: "enlaces_option",
                label: <p style={{ color: "white", margin: 0 }}>Enlaces</p>,
                children: <>
                    <FormEnlances
                      enlaces={otras}
                      handleSubmitEnlaces={handleSubmitEnlaces}
                      setEnlaces={setOtras}
                    />
                  </>,
              },
              {
                key: "mensajeria_option",
                label: <p style={{ color: "white", margin: 0 }}>Mensajería</p>,
                children: <>
                    <FormScripts
                      scriptsList={scriptsList}
                      handleSubmitScripts={handleSubmitScripts}
                      setScriptsList={setScriptsList}
                    />
                  </>,
              },
              {
                key: "asistente_option",
                label: <p style={{ color: "white", margin: 0 }}>Asistente</p>,
                children: (
                  <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ flexGrow: 1, color: "var(--inm-texto)" }}>
                        {proyecto.asistente?.ui?.nombre || "Asistente Inmersial"}
                      </span>
                      <span className={`inm-pill ${proyecto.asistente?.habilitado ? "inm-pill--asistente" : "inm-pill--neutro"}`}>
                        {proyecto.asistente?.habilitado ? "Activo" : "Apagado"}
                      </span>
                    </div>
                    <span className="inm-tenue">
                      Activalo, elegí el avatar y acomodalo sobre la escena con la vista previa.
                    </span>
                    <Button type="primary" className="inm-btn-asistente" block onClick={configurarAsistente}>
                      Configurar y ver vista previa
                    </Button>
                  </div>
                ),
              },
            ]}
          />
        </>
      ),
    },
    {
      key: 2,
      theme: "dark",
      style: { color: "white" },
      label: <p style={{ color: "white" }}>Inspector</p>,
      children: elemento ? (
        <ElementInspector
          proyecto={proyecto}
          elemento={elemento}
          escenaParaApi={escena}
          guardarCambios={guardarCambiosElemento}
          eliminarElemento={eliminarElemento}
          guardarCambiosApi={actualizarElementoAPI}
          modo={modo}
          setLoading={setLoading}
          setShowAlert={setShowAlert}
          setAlertData={setAlertData}
          actualizarExperienciaAPI={actualizarExperienciaAPI}
        />
      ) : (
        <SceneInspector
          escena={escena}
          guardarCambios={guardarCambiosEscena}
          modo={modo}
          actualizarExperienciaAPI={actualizarExperienciaAPI}
          cambiarTabKey={cambiarTabKey}
        />
      ),
    },
  ];

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const handleLogoutRoutine = () => {
    setProyecto(projectInitialState);
    setEscena(escenaVacia);
    setShowBackOffice(false);
    setSeccion("inicio");
    logout();
  };

  const [iseditingNameExperience, setIsEditingNameExperience] = useState(false);

  //sin sesion se muestra la pantalla de login en lugar del editor
  if (!authState.isLogged && !modo) {
    return <PantallaLogin />;
  }

  const bloqueTitulo = iseditingNameExperience ? (
    <div style={{ padding: "4px 14px 8px" }}>
      <Input
        aria-label="Nombre de la experiencia"
        style={{ marginBottom: 10, width: "100%" }}
        value={titleExperience}
        onChange={(e) => setTitleExperience(e.target.value)}
        onPressEnter={() => titleExperience.trim() && titleExperience !== proyecto.nombre && handleTitleExperienceChange()}
      />
      <Space style={{ width: "100%", justifyContent: "flex-end" }}>
        <Button
          onClick={() => {
            setTitleExperience(proyecto.nombre);
            setIsEditingNameExperience(false);
          }}
        >
          Cancelar
        </Button>
        <Button
          disabled={!titleExperience.trim() || titleExperience === proyecto.nombre}
          type="primary"
          onClick={handleTitleExperienceChange}
        >
          Guardar
        </Button>
      </Space>
    </div>
  ) : (
    <div style={{ display: "flex", alignItems: "center", gap: 4, padding: "4px 10px 4px 16px" }}>
      <h1
        style={{
          margin: 0,
          flexGrow: 1,
          minWidth: 0,
          font: "600 19px/1.2 var(--inm-titulos)",
          color: "var(--inm-texto)",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={titleExperience}
      >
        {titleExperience}
      </h1>
      <Tooltip title="Cambiar nombre">
        <Button
          type="text"
          aria-label="Cambiar nombre de la experiencia"
          icon={<EditOutlined />}
          onClick={() => setIsEditingNameExperience(true)}
        />
      </Tooltip>
    </div>
  );

  const panelIzquierdo = (
    <>
      <button type="button" className="inm-volver" onClick={cerrarExperiencia}>
        <ArrowLeftOutlined /> Mis experiencias
      </button>
      {bloqueTitulo}
      <div className="inm-editor__izq-scroll">{tabItems[0].children}</div>
    </>
  );

  const panelDerecho = (
    <>
      <div className="inm-editor__der-cabecera">
        <Segmented
          block
          value="propiedades"
          options={[
            { value: "propiedades", label: "Propiedades", icon: <ControlOutlined /> },
            {
              value: "copiloto",
              disabled: true,
              label: (
                <Tooltip title="Próximamente: necesita que la API permita editar experiencias desde el copiloto">
                  <span>Copiloto</span>
                </Tooltip>
              ),
              icon: <StarOutlined />,
            },
          ]}
        />
      </div>
      <div className="inm-editor__der-scroll">
        {elemento ? null : (
          <p className="inm-tenue" style={{ margin: "0 0 10px" }}>
            {escena.titulo
              ? "Escena seleccionada. Hacé clic en un elemento del visor para editarlo."
              : "Elegí una escena de la lista para empezar."}
          </p>
        )}
        {tabItems[1].children}
      </div>
    </>
  );

  const estadoGuardado = ultimoGuardado && (
    <span
      style={{
        color: ultimoGuardado.ok ? "var(--inm-texto-2)" : "#ff7875",
        whiteSpace: "nowrap",
        fontSize: 13,
      }}
    >
      {ultimoGuardado.ok ? (
        <CheckCircleOutlined style={{ color: "var(--inm-verde)" }} />
      ) : (
        <ExclamationCircleOutlined />
      )}{" "}
      {ultimoGuardado.ok
        ? `Guardado ${ultimoGuardado.hora.toLocaleTimeString("es-AR", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })}`
        : "No se pudo guardar"}
    </span>
  );

  const editor = (
    <div className="inm-editor">
      {!esMovil && (
        <aside className="inm-editor__izq" style={{ width: siderWidth }} aria-label="Escenas y ajustes">
          {panelIzquierdo}
          <div
            onMouseDown={comenzarRedimensionarSider}
            title="Arrastrar para redimensionar"
            style={{ position: "absolute", right: -3, top: 0, bottom: 0, width: 6, cursor: "col-resize", zIndex: 100 }}
          />
        </aside>
      )}

      <section className="inm-editor__centro">
        <div className="inm-editor__barra">
          {esMovil && (
            <Button icon={<UnorderedListOutlined />} aria-label="Escenas y ajustes" onClick={() => setPanelIzqAbierto(true)} />
          )}
          <span className="inm-editor__titulo" style={{ flexGrow: esMovil ? 1 : 0 }}>
            {escena.titulo || ""}
          </span>
          <Segmented
            value={vistaEditor}
            onChange={setVistaEditor}
            options={[
              { value: "escena", label: "Escena" },
              { value: "mapa", label: "Mapa" },
            ]}
          />
          <span style={{ flexGrow: 1 }} />
          {!esMovil && estadoGuardado}
          {esAngosto && (
            <Button icon={<ControlOutlined />} aria-label="Propiedades" onClick={() => setPanelDerAbierto(true)}>
              {esMovil ? null : "Propiedades"}
            </Button>
          )}
          <Button type="primary" icon={<ShareAltOutlined />} aria-label="Publicar" onClick={() => setMostrarPublicar(true)}>
            {esMovil ? null : "Publicar"}
          </Button>
        </div>
        <div className="inm-editor__visor">
          <GuardandoQueue cantidad={cambiosGuardando} />
          {/* el visor queda montado debajo del mapa para no reiniciar A-Frame al alternar vistas */}
          <div style={{ position: "absolute", inset: 0 }}>
            <T360view
              proyecto_actual={proyecto}
              escena={escena}
              seleccionarElemento={setEditingElement}
              cargar_escena={cargarEscena}
            />
          </div>
          {vistaEditor === "mapa" && (
            <MapaRecorrido
              escenas={proyecto.escenas}
              escenaActual={escenaIndex}
              onSeleccionar={(i) => {
                cargarEscena(i);
                setVistaEditor("escena");
              }}
            />
          )}
        </div>
      </section>

      {!esAngosto && (
        <aside className="inm-editor__der" aria-label="Propiedades">
          {panelDerecho}
        </aside>
      )}

      {esAngosto && (
        <Drawer
          open={panelDerAbierto}
          onClose={() => setPanelDerAbierto(false)}
          placement="right"
          width={Math.min(380, window.innerWidth)}
          title="Propiedades"
          styles={{ body: { padding: 0, display: "flex", flexDirection: "column" } }}
        >
          {panelDerecho}
        </Drawer>
      )}
      {esMovil && (
        <Drawer
          open={panelIzqAbierto}
          onClose={() => setPanelIzqAbierto(false)}
          placement="left"
          width={Math.min(320, window.innerWidth)}
          title="Escenas y ajustes"
          styles={{ body: { padding: 0, display: "flex", flexDirection: "column", background: "var(--inm-panel)" } }}
        >
          {panelIzquierdo}
        </Drawer>
      )}
    </div>
  );

  const seccionActual = (() => {
    switch (seccion) {
      case "asistentes":
        return <Asistentes onEditarExperiencia={abrirExperiencia} experienciaInicial={asistenteDe} />;
      case "analiticas":
        return <Analiticas onAbrirTableroCompleto={abrirTableroAnaliticas} />;
      case "integraciones":
        return <Integraciones comoPagina />;
      case "admin":
        return authState.role === "SUPER_ADMIN" ? (
          <AdminPage handleLogout={handleLogoutRoutine} embebido />
        ) : null;
      default:
        return (
          <MisExperiencias
            onAbrir={abrirExperiencia}
            onNueva={() => setMostrarExperienciaForm(true)}
            onEliminar={eliminarExperiencia}
            recargar={recargarLista}
          />
        );
    }
  })();

  return (
    <ConfigProvider theme={temaInmersial}>
      {proyecto.id ? (
        editor
      ) : (
        <AppShell
          seccion={seccion}
          onNavegar={navegar}
          usuario={authState.username}
          esSuperAdmin={authState.role === "SUPER_ADMIN"}
          onCerrarSesion={handleLogoutRoutine}
        >
          {seccionActual}
        </AppShell>
      )}

      <ModalSound
        showModal={showSoundModal}
        setShowModal={setShowSoundModal}
        handleAction={handleSound}
      />
      {/* ModalSinPortal agrega dos <br /> en el flujo; el modal se renderiza en un portal,
          asi que el contenedor de alto 0 evita que esos saltos muevan el layout */}
      <div style={{ height: 0, overflow: "hidden" }}>
        <ModalSinPortal
          titulo={dataModal.titulo}
          mensaje={dataModal.mensaje}
          setIsVisible={setShowModal}
          isVisible={showModal}
          success={success}
        />
      </div>

      <LoadingSpin visible={loading} />
      <ExperienciasForm
        visible={mostrarExperienciaForm}
        alCerrar={() => setMostrarExperienciaForm(false)}
        alAceptar={GenerarNuevaExperiencia}
      />
      <EscenaForm
        visible={mostrarEscenaForm}
        alCerrar={() => setMostrarEscenaForm(false)}
        alAceptar={handleCreateNewScene}
        modo={modo}
      />
      <ElementosForm
        visible={mostrarElementosForm}
        alCerrar={() => setMostrarElementosForm(false)}
        alAceptar={addElemento}
      />
      <Publicar
        projectId={proyecto}
        visible={mostrarPublicar}
        alCerrar={() => setMostrarPublicar(false)}
      />
    </ConfigProvider>
  );
};
export default BaseDesigner;
